<template>
  <div>
    <!-- start: page -->
    <form class="ecommerce-form action-buttons-fixed" @submit.prevent="submitForm" novalidate>
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">{{ translations.details }}</h2>
                  <p class="card-big-info-desc">
                    {{ translations.detailsInfo }}
                  </p>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">
                  
                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.title.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                      {{ translations.forms.labels.title }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.title"
                        v-model="title"
                      />

                      <form-error :model="$v.title" :label="translations.forms.labels.title" :dirty="$v.$dirty"/>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.abbreviation.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                      {{ translations.forms.labels.abbreviation }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.abbreviation"
                        v-model="abbreviation"
                      />

                      <form-error :model="$v.abbreviation" :label="translations.forms.labels.abbreviation" :dirty="$v.$dirty"/>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.unit.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                      {{ translations.forms.labels.unit }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.unit"
                        v-model="unit"
                      />

                      <form-error :model="$v.unit" :label="translations.forms.labels.unit" :dirty="$v.$dirty"/>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.countryId.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                      {{ translations.forms.labels.country }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="countryId"
                        :multiple="false"
                        :options="countries"
                        placeholder="Izaberite državu"
                      />

                      <form-error :model="$v.countryId" :label="translations.forms.labels.country" :dirty="$v.$dirty"/>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.symbol.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                      {{ translations.forms.labels.symbol }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.symbol"
                        v-model="symbol"
                      />

                      <form-error :model="$v.symbol" :label="translations.forms.labels.symbol" :dirty="$v.$dirty"/>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                      {{ translations.forms.labels.description }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.description"
                        v-model="description"
                      />
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row action-buttons">
        <div class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3">
          <router-link exact :to="{ name: 'Currencies' }" class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3">
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="
              submit-button
              btn btn-primary btn-px-4
              py-3
              d-flex
              align-items-center
              font-weight-semibold
              line-height-1
            "
            data-loading-text="Loading..."
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
        <!-- <div class="col-12 col-md-auto ms-md-auto mt-3 mt-md-0 ms-auto">
          <a href="#" class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1">
            <i class="bx bx-trash text-4 me-2"></i> Delete Category
          </a>
        </div> -->
      </div>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import api from '@/services/api';
import { translations } from '@/mixins';
import validations from './valdation-schema/add';
import FormError from '@/components/shared/form-errors/FormError.vue';

export default {
  name: 'AddBank',
  mixins: [translations],
  validations,
  components: { FormError, Treeselect },
  computed: {
    countries() {
      return this.$store.getters.getCountries.map((item) => {
        return {
          label: item.title,
          id: item.id,
        }
      });
    },
    isFormValid() {
      return !this.$v.$invalid;
    },
  },
  data() {
    return {
      title: '',
      description: '',
      unit: '',
      symbol: '',
      abbreviation: '',
      countryId: null
    };
  },
  methods: {
    submitForm() {
      this.$v.$touch();

      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }

      const { title, description, unit, symbol, abbreviation, countryId } = this;
      
      api
        .createCurrency({ title, description, unit, symbol, abbreviation, countryId })
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'Currencies' });
        });
    },
  },
  mounted() {
    this.$store.dispatch('getCountries', { sortBy: 'title', isSortAscending: true, retrieveAll: true });
  },
};
</script>

<style lang="scss" scoped>
.vue-treeselect__placeholder {
  color: #000;
}

.vue-treeselect__placeholder,
.vue-treeselect__single-value {
  line-height: 45px;
}

.vue-treeselect__control {
  height: 45px;
  font-size: 0.85rem;
}
</style>